"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _check = _interopRequireDefault(require("./check.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Stepper = function Stepper(_ref) {
  var totalSteps = _ref.totalSteps,
      _ref$actualStep = _ref.actualStep,
      actualStep = _ref$actualStep === void 0 ? 1 : _ref$actualStep,
      props = _objectWithoutProperties(_ref, ["totalSteps", "actualStep"]);

  return /*#__PURE__*/_react["default"].createElement(_styles.Stepper, props, _toConsumableArray(Array(totalSteps)).map(function (obj, index) {
    var isDone = index + 1 < actualStep;
    var isActive = index + 1 <= actualStep;
    return /*#__PURE__*/_react["default"].createElement(_styles.Step, _extends({
      key: index,
      totalSteps: totalSteps,
      isDone: isDone,
      isActive: isActive
    }, props), isDone && /*#__PURE__*/_react["default"].createElement("img", {
      alt: "icon",
      src: _check["default"],
      style: {
        width: 11
      }
    }));
  }));
};

Stepper.propTypes = {
  totalSteps: _propTypes["default"].number.isRequired,
  actualStep: _propTypes["default"].number,
  dotSize: _propTypes["default"].number,
  borderSize: _propTypes["default"].number,
  colorType: _propTypes["default"].string
};
Stepper.defaultProps = {
  actualStep: 1,
  dotSize: 16,
  borderSize: 2
};
var _default = Stepper;
exports["default"] = _default;